import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/infopages.scss";

function Accessibility() {
  return (
    <div className="privacy">
      <Header />
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper">
          <h1 className="page-title"><span className="base">Accessibility</span></h1>
        </div>
        <div className="columns"><div className="column main">
          <p>hetcratehub aims to make its online store usable by as many people as possible, including people who use keyboards, screen readers, zoom, or other assistive technologies.</p>

          <h4>Our approach</h4>
          <p>We work to provide meaningful headings and labels, keyboard-accessible controls, readable contrast, descriptive image alternatives, and layouts that remain usable at different screen sizes.</p>

          <h4>Need assistance?</h4>
          <p>If you encounter an accessibility barrier or need product or policy information in another usable format, email <a href="mailto:group@hetcratehub.today">group@hetcratehub.today</a>. Please include the page address and a short description of the problem. We will make reasonable efforts to help.</p>

          <h4>Ongoing improvement</h4>
          <p>Accessibility is an ongoing process. We review feedback and prioritise fixes that affect access to important shopping, support, and policy information.</p>
        </div></div>
      </main>
      <Footer />
    </div>
  );
}

export default Accessibility;
